<p-dialog
  [(visible)]="isVisible"
  [modal]="true"
  [closable]="false"
  styleClass="change-password-dialog"
>
  <ng-template #header>
    <div class="flex flex-column w-full">
      <div class="flex align-items-start justify-content-between w-full">
        <div class="flex justify-content-center align-items-center icon">
          <app-lock-03 stroke="#414651" width="20px" height="22px"></app-lock-03>
        </div>
        <app-x-close
          stroke="#ADB0B8"
          width="12"
          height="12"
          class="cursor-pointer"
          (click)="onCancel()"
        ></app-x-close>
      </div>
      <div class="flex flex-column gap-1 mt-3">
        <div class="text-lg-semibold text-gray-900">Promena lozinke</div>
        <div class="text-sm-regular text-gray-600">
          Promenite lozinku svog naloga.
        </div>
      </div>
    </div>
  </ng-template>

  <div class="flex flex-column gap-3">
    <app-field label="Stara lozinka" for="old-password">
      <app-text-input
        [hasIcon]="true"
        formCtrlId="old-pass"
        formCtrlType="password"
        ctrlPlaceholder="Unesi staru lozinku"
        [formCtrl]="oldPasswordCtrl"
      >
        <app-lock-03 stroke="#ADB0B8"></app-lock-03>
      </app-text-input>
    </app-field>

    <app-field label="Nova lozinka" for="new-password">
      <app-text-input
        [hasIcon]="true"
        formCtrlId="new-pass"
        formCtrlType="password"
        ctrlPlaceholder="Unesi novu lozinku"
        [formCtrl]="newPasswordCtrl"
      >
        <app-lock-03 stroke="#ADB0B8"></app-lock-03>
      </app-text-input>
    </app-field>
    <app-password-requirements [password]="newPasswordCtrl.value"></app-password-requirements>

    <app-field label="Potvrda nove lozinke" for="confirm-password">
      <app-text-input
        [hasIcon]="true"
        formCtrlId="confirm-pass"
        formCtrlType="password"
        ctrlPlaceholder="Potvrdi novu lozinku"
        [formCtrl]="confirmPasswordCtrl"
      >
        <app-lock-03 stroke="#ADB0B8"></app-lock-03>
      </app-text-input>
    </app-field>
  </div>

  <ng-template #footer>
    <div class="mt-2 flex justify-content-end align-items-center w-full">
      <app-button
        [btnSeverity]="ButtonSeverity.SECONDARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onCancel()"
      >
        <div class="text-sm-semibold text-gray-900">Otkaži</div>
      </app-button>
      <app-button
        class="ml-2-5"
        [btnSeverity]="ButtonSeverity.PRIMARY"
        [btnSize]="ButtonSize.MD"
        (btnClicked)="onSubmit()"
      >
        <div class="text-sm-semibold text-white">Potvrdi</div>
      </app-button>
    </div>
  </ng-template>
</p-dialog>
